module.exports = __webpack_public_path__ + "img/result_txt_jg.ef9bb815.png";